/**
 * Downloads a PDF from a given URL and saves it with a specified filename.
 * @param {string} url - The URL of the PDF to download.
 * @param {string} model - The model name to include in the filename.
 * @param {string} refcode - The refcode to include in the filename.
 */
export const handlePlanPdfDownload = (url, model, refcode=null) => {
    if (!url) return

    // Fetch the PDF file from the URL using fetch
    fetch(url)
        .then(response => {
            if (!response.ok) {
                throw new Error('handlePlanPdfDownload -> Network response was not ok')
            }
            return response.blob() // Convert the response into a Blob object
        })
        .then(blob => {
            // Create a URL for the Blob object
            const downloadUrl = URL.createObjectURL(blob)

            // Create a temporary anchor element to initiate download
            const link = document.createElement('a')
            link.href = downloadUrl

            let fileName

            if (refcode) {
                // Set the download filename
                fileName = `${model}-${refcode}.pdf`
            } else {
                const params = new URL(url).searchParams;
                const encodedPdfUrl = params.get("url");
                const pdfUrl = decodeURIComponent(encodedPdfUrl);
                fileName = pdfUrl.substring(pdfUrl.lastIndexOf("/") + 1);
            }
            link.setAttribute('download', fileName)

            // Append the link to the body and trigger the download
            document.body.appendChild(link)
            link.click()

            // Clean up: remove the link and revoke the object URL
            document.body.removeChild(link)
            URL.revokeObjectURL(downloadUrl)
        })
        .catch(error => {
            console.error('handlePlanPdfDownload -> Failed to download the file', error)
        })
}


export const getFormatConfigData = (config, isPlanAccepted, locale, units, planDocumentUrl, refcode) => {
    // console.log('getFormatConfigData: ', config)
    return {
        "config": {
            ...config.configuration,
            isPlanAccepted: isPlanAccepted,
            planDocumentUrl: planDocumentUrl,
            refcode: refcode,
            reference: config.reference,
        },
        "colorId": config.configuration.material && config.configuration.material.color,
        "finish": config.configuration.material && config.configuration.material.finish,
        "brand": getBrand(config),
        "colorName": config.configuration.material && config.configuration.material.colorName,
        "elaboration": getElaborationType(config.configuration.product),
        "ref": config.reference,
        "lang": locale,
        "units": units
    }
}

const getBrand = (config) =>{
    if (config.configuration.product === 'flooring-skirting') return 'FLOORING_SKIRTING'
    return config.configuration.material && config.configuration.material.brand
}

const getElaborationType = (product) => {
    switch (product) {
        case 'showertrays':
            return 'SHOWER_NEW';
        case 'washbasins':
            return 'SINK_NEW';
        case 'flooring-skirting':
            return 'CONFIGURABLE_FLOORING'
        default:
            return 'CONFIGURABLE_BATH';
    }
}

export const getCheckoutLineId = (checkoutLines, refcode) => {
    if (!refcode) {
        return null
    }

    const matchingLine = checkoutLines && checkoutLines.find(line =>
        line.cutToSize &&
        line.cutToSize.config &&
        line.cutToSize.ref &&
        line.cutToSize.ref === refcode
    )

    return matchingLine ? matchingLine.lineId : null
}

export const getConfigurablePlanPdfUrl = (configurableDrawingList, refcode) => {
    const configurableDrawing = configurableDrawingList && refcode && configurableDrawingList[refcode]

    return configurableDrawing && configurableDrawing.documentUrl
}